export type {
  SkeletonSlots,
  SkeletonBaseProps as SkeletonProps,
  SkeletonBaseState as SkeletonState,
  SkeletonContextValues,
} from '@fluentui/react-skeleton';
